import '../styles/main.css';
import { initReveal } from './modules/reveal.js';
import { initVimeoModal } from './modules/vimeo-modal.js';
import { initVimeoThumbs } from './modules/vimeo-thumbs.js';
import { initGallery } from './modules/gallery.js';

function setYear() {
  const el = document.getElementById('year');
  if (el) el.textContent = new Date().getFullYear();
}

function boot() {
  setYear();
  initReveal();
  initVimeoModal();
  initVimeoThumbs();
  initGallery();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
